import { INSIDE_LAYOUT_CONTENT_CONTAINER_ID } from "layouts/common/inside/MprcLayoutInside";
import React, { useEffect, useState } from "react";

export type StackPageContextType = {
    addPage: (page: React.ReactNode) => void;
    backPage: () => void;
    clearPages: () => void;
    renderPages: () => React.ReactNode[];
    count: number;
};

export const StackPageContext = React.createContext<StackPageContextType>(null!);
export const useStackView = () => React.useContext(StackPageContext);

interface IProps extends React.PropsWithChildren {
    childrenIsFirstPage?: boolean;
}

export const MprcStackPageProvider = ({ childrenIsFirstPage = false, children }: IProps) => {
    const [stackPages, setStackPages] = useState<Array<React.ReactNode>>(childrenIsFirstPage ? [children] : []);

    useEffect(() => {
        //Volta scroll para o topo sempre que houver mudança de página
        document.getElementById(INSIDE_LAYOUT_CONTENT_CONTAINER_ID)?.scrollTo(0, 0);
    }, [stackPages]);

    const renderPages = () => {
        return stackPages.map((p, i) => <div key={i} style={{ display: i < stackPages.length - 1 ? "none" : "" }}>{p}</div>);
    };

    return (
        <StackPageContext.Provider
            value={
                {
                    addPage: (page: React.ReactNode) => {
                        setStackPages(state => [...state, page]);
                    },
                    backPage: () => stackPages.length > 0 && setStackPages(state => state.slice(0, -1)),
                    clearPages: () => setStackPages([]),
                    renderPages: renderPages,
                    count: stackPages.length
                }
            }
        >
            {childrenIsFirstPage ? renderPages() : children}
        </StackPageContext.Provider>
    );
};
